import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-the-c01-form-note-panel-shortage" }
const _hoisted_2 = {
  key: 0,
  class: "p-the-c01-form-note-panel-shortage__content p-the-c01-form-note-panel-shortage__content--credit"
}
const _hoisted_3 = { class: "p-the-c01-form-note-panel-shortage__icon" }
const _hoisted_4 = {
  key: 1,
  class: "p-the-c01-form-note-panel-shortage__content"
}
const _hoisted_5 = {
  key: 1,
  class: "p-the-c01-form-note-panel-shortage__content"
}
const _hoisted_6 = {
  key: 1,
  class: "p-the-c01-form-note-panel-shortage__content"
}
const _hoisted_7 = {
  key: 1,
  class: "p-the-c01-form-note-panel-shortage__content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconCreditCard = _resolveComponent("IconCreditCard")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.compareSaleEndDate(_ctx.saleEndDate))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.possession > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.creditCardEnabled)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.cartEmpty && _ctx.count == 1 && _ctx.type !== 'gift_card')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_IconBase, {
                                width: 40,
                                height: 40,
                                "view-box": "0 0 40 40",
                                "icon-color": "#000"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_IconCreditCard)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[0] || (_cache[0] = _createElementVNode("p", null, " ポイントが不足しているため、不足分はクレジットカードでのお支払いが必要です。 ", -1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, " ポイントが不足しているため、こちらの商品はお申込みできません "))
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, " ポイントが不足しているため、こちらの商品はお申込みできません "))
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, " ポイントが不足しているため、こちらの商品はお申込みできません "))
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, " この商品は現在販売しておりません。 "))
  ]))
}